import { render, staticRenderFns } from "./ArticleCardRemove.vue?vue&type=template&id=2aa7f9a6&scoped=true"
import script from "./ArticleCardRemove.vue?vue&type=script&lang=js"
export * from "./ArticleCardRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7f9a6",
  null
  
)

export default component.exports